import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './Feedback.module.scss';
import { SmileyHappyIcon, SmileyIndifferentIcon, SmileySadIcon, SmileySmirkIcon, SmileyUnhappyIcon, } from '../../components';
import { PureButton } from '../../basics';
import { ButtonType } from '../../enums';
const ratings = [1, 2, 3, 4, 5];
const feedbackIcons = {
    1: SmileySadIcon,
    2: SmileyUnhappyIcon,
    3: SmileyIndifferentIcon,
    4: SmileySmirkIcon,
    5: SmileyHappyIcon,
};
const Feedback = ({ handleOnClick, selectedRating, iconSize }) => (_jsx(_Fragment, { children: ratings.map(rating => {
        const FeedbackIcon = feedbackIcons[rating];
        return (_jsx(PureButton, { type: ButtonType.Button, onClick: () => handleOnClick(rating), className: classnames(styles.feedbackIcon, {
                [styles.isHidden]: selectedRating !== 0 && selectedRating !== rating,
                [styles.isSelected]: selectedRating === rating,
            }), children: _jsx(FeedbackIcon, { size: iconSize }) }, rating));
    }) }));
export { Feedback };
